<template>
  <div
    :class="[
      'image',
      'message-text__wrap',
      'content-img-loader',
      { 'no-before': hasError },
    ]"
  >
    <template v-if="hasError">
      <image-error-placeholder
        :is-incoming="isIncoming"
        :sub-title="errorMessage"
        :type="'image'"
        :is-private="isPrivate"
      />
    </template>
    <template v-else>
      <img
        :id="'img-content-' + id"
        :src="imageUrl"
        :alt="'img' + id"
        class="image-loader"
        @click="onClick"
        @error="onImgError"
        @load="onLoaded"
      />
      <woot-modal :full-width="true" :show.sync="show" :on-close="onClose">
        <img :src="url" class="modal-image" />
      </woot-modal>
    </template>
  </div>
</template>

<script>
import { getBytesImg } from '../../../../helper/commons';
import Unavailable from './Unavailable.vue';
export default {
  components: {
    ImageErrorPlaceholder: Unavailable,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    isIncoming: {
      type: Boolean,
      default: false,
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      imageUrl: 'https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif',
      hasError: false,
      errorMessage: '',
    };
  },
  watch: {
    url: {
      immediate: true,
      handler(newUrl) {
        if (newUrl && newUrl.trim()) {
          this.onGenerateImage();
        }
      },
    },
  },
  async mounted() {
    // Solo ejecutar si url ya tiene valor al montar
    if (this.url && this.url.trim()) {
      await this.onGenerateImage();
    }
  },
  methods: {
    /**
     * Método emitir evento al componente padre avisando que la imagen ha sido cargada
     */
    onLoaded() {
      this.$emit('load');
    },
    onClose() {
      this.show = false;
    },
    onClick() {
      this.show = true;
    },
    onImgError() {
      this.errorMessage = this.$t('CONVERSATION.IMAGE_NOT_AVAILABLE');
      this.hasError = true;
    },
    async onGenerateImage() {
      // Validar que url tenga valor antes de proceder
      if (!this.url || !this.url.trim()) {
        console.log('URL no válida, esperando valor...');
        return;
      }

      try {
        const image = document.getElementById(`img-content-${this.id}`);
        this.imageUrl = await getBytesImg(this.url);
        if (image) {
          image.className = '';
          const parent = image.parentElement;
          if (parent) {
            parent.className = 'image message-text__wrap';
          }
        }
      } catch (error) {
        console.error('[ERROR]', error);
        this.onImgError();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-img-loader {
  display: flex;
  width: 32rem;
  justify-content: center;
  height: 20rem;
  align-items: center;
}
.image-loader {
  width: 50px;
  height: 50px;
}
</style>
